// Índice de la documentación: es la única fuente del orden, las rutas y el buscador.
// Añadir una página = añadir una entrada aquí y su componente. Nada más.
import { Portada, Canal, PrimerVideo } from "./s1-empezar";
import { UnClic, Revision, Material, Calendario, Voz } from "./s2-crear";
import { VistaManual, Guion, MaterialManual, Composicion, Publicar } from "./s3-editar";
import { QueEsCredito, Planes, Recargas, Acciones } from "./s4-creditos";
import { Nicho, Titulos, Retencion, Publicar as PublicarGuia } from "./s5-guias";
import { FaltaMaterial, EnCola, SeParo, MaterialRaro, Otros } from "./s6-problemas";

// `claves` alimenta el buscador: son los términos por los que alguien buscaría esa página aunque
// no coincidan con su título (lo que escribe un usuario perdido rara vez es el título exacto).
export const SECCIONES = [
  {
    id: "empezar",
    titulo: "Empezar",
    paginas: [
      { id: "introduccion", titulo: "Qué es YTMethod", Comp: Portada,
        claves: "inicio introducción overview qué es para qué sirve empezar" },
      { id: "canal", titulo: "Crear un canal", Comp: Canal,
        claves: "canal temática idioma voz youtube conectar configurar" },
      { id: "primer-video", titulo: "Tu primer vídeo", Comp: PrimerVideo,
        claves: "primer vídeo tutorial empezar paso a paso cuánto tarda" },
    ],
  },
  {
    id: "crear",
    titulo: "Crear vídeos",
    paginas: [
      { id: "un-clic", titulo: "Producción en 1 clic", Comp: UnClic,
        claves: "1 clic un clic producción automática título duración guion" },
      { id: "revision", titulo: "La parada de revisión", Comp: Revision,
        claves: "revisar aprobar revisión antes de renderizar previsualizar material" },
      { id: "material", titulo: "De dónde sale el material", Comp: Material,
        claves: "material b-roll broll archivo fuentes pexels wikimedia imágenes ia stock" },
      { id: "calendario", titulo: "Calendario automático", Comp: Calendario,
        claves: "calendario automático programar publicar ideas fechas" },
      { id: "voz", titulo: "La narración", Comp: Voz,
        claves: "voz narración locución acento idioma hablar audio" },
    ],
  },
  {
    id: "editar",
    titulo: "Editar",
    paginas: [
      { id: "vista-manual", titulo: "La vista manual", Comp: VistaManual,
        claves: "manual avanzado pestañas editar detalle" },
      { id: "guion", titulo: "Guion", Comp: Guion,
        claves: "guion texto escenas escribir pegar mejorar storyboard" },
      { id: "material-manual", titulo: "Cambiar el material", Comp: MaterialManual,
        claves: "cambiar clip sustituir subir vídeo propio cobertura" },
      { id: "composicion", titulo: "Composición y estilo", Comp: Composicion,
        claves: "música subtítulos estilo rótulos partículas montaje transiciones" },
      { id: "publicar", titulo: "Miniatura y publicación", Comp: Publicar,
        claves: "miniatura thumbnail publicar youtube subir descargar mp4" },
    ],
  },
  {
    id: "creditos",
    titulo: "Créditos y planes",
    paginas: [
      { id: "que-es-un-credito", titulo: "Qué es un crédito", Comp: QueEsCredito,
        claves: "crédito créditos saldo consumo cuánto cuesta minutos" },
      { id: "planes", titulo: "Los planes", Comp: Planes,
        claves: "planes precio suscripción starter creator pro gratis anual" },
      { id: "recargas", titulo: "Recargas de saldo", Comp: Recargas,
        claves: "recarga comprar créditos saldo extra pack" },
      { id: "acciones", titulo: "Qué consume créditos", Comp: Acciones,
        claves: "consumo coste acciones gastar ahorrar miniatura guion render" },
    ],
  },
  {
    id: "guias",
    titulo: "Guías",
    paginas: [
      { id: "nicho", titulo: "Elegir un nicho", Comp: Nicho,
        claves: "nicho temática elegir tema canal faceless material disponible" },
      { id: "titulos", titulo: "Títulos que funcionan", Comp: Titulos,
        claves: "título titulo clickbait ctr escribir gancho" },
      { id: "retencion", titulo: "Retención y ritmo", Comp: Retencion,
        claves: "retención retencion ritmo gancho apertura duración abandono" },
      { id: "publicar-bien", titulo: "Publicar con constancia", Comp: PublicarGuia,
        claves: "publicar constancia frecuencia métricas analíticas crecer" },
    ],
  },
  {
    id: "problemas",
    titulo: "Problemas",
    paginas: [
      { id: "falta-material", titulo: "Dice que falta material", Comp: FaltaMaterial,
        claves: "falta material no puedo renderizar cobertura completar error" },
      { id: "en-cola", titulo: "El vídeo está en cola", Comp: EnCola,
        claves: "cola esperando render tarda lento turno" },
      { id: "se-paro", titulo: "La producción se paró", Comp: SeParo,
        claves: "parado cortado error sin saldo retomar continuar bloqueado" },
      { id: "material-raro", titulo: "El material no pega con el guion", Comp: MaterialRaro,
        claves: "material raro no tiene que ver descolocado imágenes equivocadas" },
      { id: "otros", titulo: "Otros problemas", Comp: Otros,
        claves: "voz youtube subida miniatura verificada almacenamiento borrado soporte" },
    ],
  },
];

// Lista plana en orden de lectura, para el anterior/siguiente y el buscador.
export const PAGINAS = SECCIONES.flatMap((s) =>
  s.paginas.map((p) => ({ ...p, seccion: s.id, seccionTitulo: s.titulo }))
);

export const buscarPaginas = (q) => {
  const t = q.trim().toLowerCase();
  if (t.length < 2) return [];
  return PAGINAS.filter((p) =>
    p.titulo.toLowerCase().includes(t) ||
    p.claves.includes(t) ||
    p.seccionTitulo.toLowerCase().includes(t)
  ).slice(0, 8);
};
